import { IOrganization } from '../interface/organization';
export class Organization implements IOrganization  {
    constructor(public OrgId : number,public OrgName : string,public OrgAddress : string, public OrgContactNo : number ){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/organization.ts